angular.module 'app'
.controller 'AddArticleSelectCtrl', ($scope, $uibModalInstance, $state, config, growl, dialogs) ->

  # end save
  $scope.toGo = (flag) ->
    $uibModalInstance.close flag
